import type { CSSProperties, ReactNode } from "react";
import type { LucideIcon } from "lucide-react";
import { Check } from "lucide-react";

type StepHeaderProps = {
  current: number;
  total: number;
  onBack: () => void;
};

type StepProgressStyle = CSSProperties & {
  "--step-progress": string;
};

export function WizardStepHeader({
  current,
  total,
  onBack,
}: StepHeaderProps) {
  const progress = `${Math.min(100, Math.max(0, (current / total) * 100))}%`;
  return (
    <div className="tp-wizard-head tp-resource-step-header">
      <button
        type="button"
        onClick={onBack}
        className="tp-flow-back-button"
        aria-label="назад"
      >
        ←
      </button>
      <div className="tp-resource-step-center">
        <span
          className="tp-resource-step-badge"
          style={{ "--step-progress": progress } as StepProgressStyle}
        >
          <span>{current}</span>
        </span>
        <span className="tp-resource-step-label">
          шаг {current} из {total}
        </span>
      </div>
      <span aria-hidden="true" />
    </div>
  );
}

type ChoiceCardProps = {
  label: string;
  active: boolean;
  icon:
    | LucideIcon
    | ((props: { className?: string; "aria-hidden"?: true }) => ReactNode);
  onClick: () => void;
};

export function ChoiceCard({
  label,
  active,
  icon: Icon,
  onClick,
}: ChoiceCardProps) {
  return (
    <button
      type="button"
      aria-pressed={active}
      className="tp-choice-button"
      data-active={active}
      onClick={onClick}
    >
      <span className="tp-choice-button-main">
        <Icon className="tp-choice-button-icon" aria-hidden={true} />
        <span>{label}</span>
      </span>
      <Check className="tp-choice-button-check" aria-hidden="true" />
    </button>
  );
}

type InstructionStep = {
  text: ReactNode;
};

export function InstructionSteps({ steps }: { steps: InstructionStep[] }) {
  return (
    <div className="tp-resource-instruction-card">
      {steps.map((step, index) => (
        <div key={index} className="tp-resource-instruction-row">
          <span className="tp-resource-instruction-marker">
            <span>{index + 1}</span>
          </span>
          <div className="tp-resource-instruction-text">{step.text}</div>
        </div>
      ))}
    </div>
  );
}

export function FieldLabel({ children }: { children: ReactNode }) {
  return <div className="tp-resource-field-label">{children}</div>;
}
